/**
 * !!!!! GENERATED FILE !!!!!
 * source: 
 * target: /src/bridge/user-center-api.generate.ts
 *
 */
import {ApiRequest, ApiResponse} from "@gongt/ts-stl-library/request/protocol";
import {ERequestType} from "@gongt/ts-stl-library/request/request";
import {IUserProfileBase} from "./define";

import {
	CheckPermissionBody,
	CheckPermissionMethod,
	CheckPermissionResponse,
	CheckPermissionUrl
} from "./protocol/check-permission.protocol";
import {
	ThirdPartyLoginBody,
	ThirdPartyLoginMethod,
	ThirdPartyLoginResponse,
	ThirdPartyLoginUrl,
} from "./protocol/third-party-login.protocol";
import {
	DeleteUserBody,
	DeleteUserMethod,
	DeleteUserResponse,
	DeleteUserUrl,
} from "./protocol/delete-user.protocol";
import {
	DropPermissionBody,
	DropPermissionMethod,
	DropPermissionResponse,
	DropPermissionUrl
} from "./protocol/drop-permission.protocol";
import {
	GrantPermissionBody,
	GrantPermissionMethod,
	GrantPermissionResponse,
	GrantPermissionUrl
} from "./protocol/grant-permission.protocol";
import {
	UserLoginBody,
	UserLoginMethod,
	UserLoginResponse,
	UserLoginUrl,
} from "./protocol/user-login.protocol";
import {
	UserLogoutBody,
	UserLogoutMethod,
	UserLogoutResponse,
	UserLogoutUrl,
} from "./protocol/user-logout.protocol";
import {
	UserRegisterBody,
	UserRegisterMethod,
	UserRegisterResponse,
	UserRegisterUrl,
} from "./protocol/user-register.protocol";
import {
	UpdateAvatarBody,
	UpdateAvatarMethod,
	UpdateAvatarResponse,
	UpdateAvatarUrl,
} from "./protocol/update-avatar.protocol";
import {
	UpdatePasswordBody,
	UpdatePasswordMethod,
	UpdatePasswordResponse,
	UpdatePasswordUrl,
} from "./protocol/update-password.protocol";
import {
	UpdateProfileBody,
	UpdateProfileMethod,
	UpdateProfileResponse,
	UpdateProfileUrl,
} from "./protocol/update-profile.protocol";
import {
	DumpPermissionBody,
	DumpPermissionMethod,
	DumpPermissionResponse,
	DumpPermissionUrl,
} from "./protocol/dump-permission.protocol";
import {
	GetCurrentUserMethod,
	GetCurrentUserRequest,
	GetCurrentUserResponse,
	GetCurrentUserUrl,
} from "./protocol/get-current-user.protocol";
import {
	GetUserListByIdMethod,
	GetUserListByIdRequest,
	GetUserListByIdResponse,
	GetUserListByIdUrl,
} from "./protocol/get-user-list.protocol";
import {
	GetUserProfileMethod,
	GetUserProfileRequest,
	GetUserProfileResponse,
	GetUserProfileUrl,
} from "./protocol/get-user-profile.protocol";
import {
	GetVerifyMethod,
	GetVerifyRequest,
	GetVerifyResponse,
	GetVerifyUrl,
	VerifyImageUrl,
} from "./protocol/get-verify-code.protocol";
import {
	SendResetEmailBody,
	SendResetEmailMethod,
	SendResetEmailResponse,
	SendResetEmailUrl,
} from "./protocol/send-request-email.protocol";

export abstract class UserCenterApiList<IProfile extends IUserProfileBase> {
	protected abstract _do_request<Req extends ApiRequest, Res extends ApiResponse>(method: ERequestType, url: string, req: Req): Promise<Res>;
	
	constructor(){
		for(const name of ["checkPermission", "thirdPartyLogin", "deleteUser", "dropPermission", "grantPermission", "userLogin", "userLogout", "userRegister", "updateAvatar", "updatePassword", "updateProfile", "dumpPermission", "getCurrentUser", "getUserListById", "getUserProfile", "getVerify", "sendResetEmail"]) {
			this[name] = this[name].bind(this);
		}
	}
	
	
	public checkPermission(request: CheckPermissionBody): Promise<CheckPermissionResponse> {
		return this._do_request(CheckPermissionMethod, CheckPermissionUrl, request);
	}
	
	public thirdPartyLogin(request: ThirdPartyLoginBody): Promise<ThirdPartyLoginResponse<IProfile>> {
		return this._do_request(ThirdPartyLoginMethod, ThirdPartyLoginUrl, request);
	}
	
	public deleteUser(request: DeleteUserBody): Promise<DeleteUserResponse> {
		return this._do_request(DeleteUserMethod, DeleteUserUrl, request);
	}
	
	public dropPermission(request: DropPermissionBody): Promise<DropPermissionResponse> {
		return this._do_request(DropPermissionMethod, DropPermissionUrl, request);
	}
	
	public grantPermission(request: GrantPermissionBody): Promise<GrantPermissionResponse> {
		return this._do_request(GrantPermissionMethod, GrantPermissionUrl, request);
	}
	
	public userLogin(request: UserLoginBody): Promise<UserLoginResponse<IProfile>> {
		return this._do_request(UserLoginMethod, UserLoginUrl, request);
	}
	
	public userLogout(request: UserLogoutBody): Promise<UserLogoutResponse> {
		return this._do_request(UserLogoutMethod, UserLogoutUrl, request);
	}
	
	public userRegister(request: UserRegisterBody): Promise<UserRegisterResponse<IProfile>> {
		return this._do_request(UserRegisterMethod, UserRegisterUrl, request);
	}
	
	public updateAvatar(request: UpdateAvatarBody): Promise<UpdateAvatarResponse> {
		return this._do_request(UpdateAvatarMethod, UpdateAvatarUrl, request);
	}
	
	public updatePassword(request: UpdatePasswordBody): Promise<UpdatePasswordResponse> {
		return this._do_request(UpdatePasswordMethod, UpdatePasswordUrl, request);
	}
	
	public updateProfile(request: UpdateProfileBody): Promise<UpdateProfileResponse> {
		return this._do_request(UpdateProfileMethod, UpdateProfileUrl, request);
	}
	
	public dumpPermission(request: DumpPermissionBody): Promise<DumpPermissionResponse> {
		return this._do_request(DumpPermissionMethod, DumpPermissionUrl, request);
	}
	
	public getCurrentUser(request: GetCurrentUserRequest): Promise<GetCurrentUserResponse<IProfile>> {
		return this._do_request(GetCurrentUserMethod, GetCurrentUserUrl, request);
	}
	
	public getUserListById(request: GetUserListByIdRequest): Promise<GetUserListByIdResponse<IProfile>> {
		return this._do_request(GetUserListByIdMethod, GetUserListByIdUrl, request);
	}
	
	public getUserProfile(request: GetUserProfileRequest): Promise<GetUserProfileResponse<IProfile>> {
		return this._do_request(GetUserProfileMethod, GetUserProfileUrl, request);
	}
	
	public getVerify(request: GetVerifyRequest): Promise<GetVerifyResponse> {
		return this._do_request(GetVerifyMethod, GetVerifyUrl, request);
	}
	
	public sendResetEmail(request: SendResetEmailBody): Promise<SendResetEmailResponse> {
		return this._do_request(SendResetEmailMethod, SendResetEmailUrl, request);
	}
}
